export const ButtonStyles = {
    outline: 'outline',
    outlineSecondary: 'outline-secondary',
    secondary: 'secondary',
    basket: 'basket',
    icon: 'icon'
};

export const allProductsUrl = '/products';